// extracted by mini-css-extract-plugin
module.exports = {"header":"RiskAlertHeader_header__1XiNa","tags":"RiskAlertHeader_tags__31grR"};